import type { ReactElement } from 'react'
import styled from 'styled-components'

import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Detailed } from '@/components/pages/Remoteworktown/Detailed'

import type { RemoteProps } from '@/types/remoteworktown'

export const RemoteworktownPage = ({ topics }: RemoteProps) => {
  return (
    <RemoteworktownMain>
      <Detailed topics={topics} />
    </RemoteworktownMain>
  )
}

const pageTitle = {
  title: 'REMOTEWORK TOWN',
  subTitle: 'リモートワークタウン ムスブ宮若',
}

RemoteworktownPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'リモートワークタウン ムスブ宮若', path: '' },
  ]
  return (
    <>
      <Head
        title="リモートワークタウン ムスブ宮若"
        description="トライアルホールディングスの企業情報を掲載しています。"
        ogp={{ url: '/Remoteworktown/' }}
      />
      <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs}>
        {page}
      </TitleLayout>
    </>
  )
}

const RemoteworktownMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 98px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 0 20px 70px;
  }
`
